class CTCampaignFeedback {
  constructor(section) {
    this.section = section;
    this.viewport = section.querySelector(
      '[data-ct-feedback-viewport]'
    );
    this.track = section.querySelector(
      '.ct-campaign-feedback__track'
    );
    this.previousButton = section.querySelector(
      '[data-ct-feedback-previous]'
    );
    this.nextButton = section.querySelector(
      '[data-ct-feedback-next]'
    );

    if (!this.viewport || !this.track) return;

    this.bindEvents();
    this.updateNavigation();
  }

  bindEvents() {
    this.previousButton?.addEventListener('click', () => {
      this.scroll(-1);
    });

    this.nextButton?.addEventListener('click', () => {
      this.scroll(1);
    });

    this.viewport.addEventListener(
      'scroll',
      () => this.updateNavigation(),
      { passive: true }
    );

    this.section.addEventListener('click', (event) => {
      const toggle = event.target.closest(
        '[data-ct-review-toggle]'
      );

      if (!toggle) return;

      const card = toggle.closest(
        '[data-ct-feedback-card]'
      );

      if (!card) return;

      const isExpanded =
        toggle.getAttribute('aria-expanded') === 'true';

      const nextExpandedState = !isExpanded;

      card.classList.toggle(
        'is-expanded',
        nextExpandedState
      );

      toggle.setAttribute(
        'aria-expanded',
        String(nextExpandedState)
      );

      const label = toggle.querySelector(
        '[data-ct-review-toggle-label]'
      );

      if (label) {
        label.textContent = nextExpandedState
          ? toggle.dataset.lessLabel
          : toggle.dataset.moreLabel;
      }
    });

    window.addEventListener(
      'resize',
      () => this.updateNavigation()
    );
  }

  getScrollDistance() {
    const firstCard = this.track.querySelector(
      '[data-ct-feedback-card]'
    );

    if (!firstCard) return this.viewport.clientWidth;

    const trackStyle = window.getComputedStyle(this.track);
    const gap = parseFloat(trackStyle.columnGap) || 0;

    return firstCard.getBoundingClientRect().width + gap;
  }

  scroll(direction) {
    this.viewport.scrollBy({
      left: direction * this.getScrollDistance(),
      behavior: 'smooth',
    });
  }

  updateNavigation() {
    if (!this.previousButton || !this.nextButton) return;

    const maximumScroll =
      this.viewport.scrollWidth -
      this.viewport.clientWidth;

    const currentScroll = this.viewport.scrollLeft;

    this.previousButton.disabled = currentScroll <= 2;

    this.nextButton.disabled =
      currentScroll >= maximumScroll - 2;
  }
}

function initializeCTCampaignFeedback(root = document) {
  root
    .querySelectorAll(
      '[data-ct-feedback-section]:not([data-ct-feedback-initialized])'
    )
    .forEach((section) => {
      section.setAttribute(
        'data-ct-feedback-initialized',
        'true'
      );

      new CTCampaignFeedback(section);
    });
}

document.addEventListener(
  'DOMContentLoaded',
  () => initializeCTCampaignFeedback()
);

document.addEventListener(
  'shopify:section:load',
  (event) => initializeCTCampaignFeedback(event.target)
);